export enum SortByEnum {
  PriceLowHigh = 'priceLowHigh',
  PriceHighLow = 'priceHighLow',
  CoachRating = 'coachRating',
  PlayersGoing = 'playersGoing',
  NearestTime = 'nearestTime',
  Distance = 'distance',
}

export enum TimeEnum {
  All = 'all',
  Morning = 'morning',
  Afternoon = 'afternoon',
  Evening = 'evening',
}

/**
 * The "Type" tabs in the clinic filters modal. A filter-level concept, not a database
 * one — each tab is a predicate over the row (`CLINIC_TYPE_MATCH` in ./constants),
 * since Fitness spans Cardio lessons and RFX events.
 */
export enum ClinicTypeFilter {
  Clinic = 'clinic',
  Fitness = 'fitness',
  Camp = 'camp',
}

/** The "Court type" tabs. Matched against the venue's indoor/outdoor court counts. */
export enum CourtTypeFilter {
  Indoor = 'indoor',
  Outdoor = 'outdoor',
}
